<template>
  <div class="notesList_wrapper wrapper">
    <transition name="fade" v-if="showModal">
      <Modal @close="invertModalStatus" :can-scroll="true">
        <div slot="content">
          <div class="content-header inner">
            <h2>
              <span>注意事項</span>
            </h2>
            <button @click="invertModalStatus" class="close-btn">
              <fa-icon icon="times" />
            </button>
          </div>
          <div class="boxTxt_inner inner">
            <h3>
              <span>動作環境</span>
            </h3>
            <ul>
              <li>ビデオ会議は処理負荷が高い機能のため、お使いのデバイス（PC、スマートフォン、タブレット等）の性能によって品質が左右されます。</li>
              <li>PC：Windows10、macOS X</li>
              <li>Google Chrome、Firefox、Safari、Microsoft Edge それぞれ安定版の最新2バージョン</li>
              <li>Android</li>
              <li>Google Chrome 安定版の最新2バージョン</li>
              <li>iOS</li>
              <li>Safari 安定版の最新2バージョン</li>
            </ul>
            <h3>
              <span>アドバイスをする</span>
            </h3>
            <ul>
              <li>
                ビデオ会議は急速に広がっていますが、まだまだ利用者は少ないです。<br />はじめての方や使い方を学習中の方など様々な方がいます。<br />困っていたり迷惑をかけるような使い方をしている人には積極的にアドバイスをお願いします。
              </li>
            </ul>
            <h3>
              <span>アドバイスをもらう</span>
            </h3>
            <ul>
              <li>
                会社や業界ごとにローカルルールがあって、意図せず不快な使い方をしている場合がありますし、自分たちのルールとあわないアドバイスをもらうこともあるかと思いますが、<br />まずは好意だと思って受け止めて下さい。
              </li>
            </ul>
            <h3>
              <span>ビデオ会議のよくあるマナー①</span>
            </h3>
            <ul>
              <li>誰かが話しているときは自らのマイクをなるべくミュートにする（ノイズや生活音を入れない）</li>
            </ul>
            <h3>
              <span>ビデオ会議のよくあるマナー②</span>
            </h3>
            <ul>
              <li>
                映像やネットワークが不安定に思える時は自らの映像をオフにして、通信量を減らしてみましょう。自分の映像を受け取る相手側の負荷が下がることで改善するケースがあります。
              </li>
            </ul>
            <h3>
              <span>ビデオ会議のよくあるマナー③</span>
            </h3>
            <ul>
              <li>
                説明会の途中退席・離席、子供の乱入、電話がなってしまう等、本人の意図するしないにかかわらずトラブルは発生しますが、そういうものだと思って楽しみましょう。
              </li>
            </ul>
            <h3>
              <span>ビデオ会議のよくあるマナー④</span>
            </h3>
            <ul>
              <li>
                通信の影響で微妙な間があくことがあります。<br />慣れないと、つい「何かしゃべらなきゃ、、」となって自分だけがしゃべってしまいがちになることがありますが、このようなときは「ちょっと落ち着こう」という合図だと思って一呼吸おきましょう。
              </li>
            </ul>
            <h3>
              <span>Zoomがいい（他のアプリの方が使いやすい）</span>
            </h3>
            <ul>
              <li>至らない点をお気軽にスタッフにお伝えください。<br />今後の改善の検討項目に追加し努力していきたいと思います。</li>
            </ul>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Modal from "../elements/Modal"

export default {
  name: "Caution",
  components: {
    Modal
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    invertModalStatus() {
      this.$emit("invert-modal-status")
    }
  }
}
</script>
